import { create } from 'zustand';

/**
 * Team membership state. `teams` is read by the Teams page, ActivityBar
 * (badge), CommandPalette and TauriTitleBar; `teamLibraryRefresh` is a trigger
 * bumped after sharing to a team so the Teams library refetches.
 *
 * Setters are exported as stable module-level functions (named identically to
 * the old useState setters). They mirror useState semantics (value or updater).
 */
const initialState = {
  teams: [],
  teamLibraryRefresh: null,
};

const make = (set, key) => (value) =>
  set((state) => ({ [key]: typeof value === 'function' ? value(state[key]) : value }));

export const useTeamsStore = create((set) => ({
  ...initialState,
  setTeams: make(set, 'teams'),
  setTeamLibraryRefresh: make(set, 'teamLibraryRefresh'),
  reset: () => set({ ...initialState }),
}));

export const setTeams = (v) => useTeamsStore.getState().setTeams(v);
export const setTeamLibraryRefresh = (v) => useTeamsStore.getState().setTeamLibraryRefresh(v);
